module.exports = __webpack_public_path__ + "static/media/quote.b8aeb249.svg";